import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({
    tag: "component",
    staticClass: "v-font-preview",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      "aria-selected": _vm.selectable ? _vm.isSelected.toString() : null
    }
  }, 'component', Object.assign({}, _vm.attributes, _vm.$attrs), false), Object.assign({}, _vm.$listeners, {
    click: _vm.handleClick
  })), [_c('div', {
    ref: "rootRef",
    staticClass: "v-font-preview__header"
  }, [_c('div', {
    staticClass: "v-font-preview__header-inner"
  }, [_c('VText', {
    staticClass: "v-font-preview__title"
  }, [_vm._v("\n        " + _vm._s(_vm.value) + "\n      ")]), _vm._v(" "), _vm.subtitle ? _c('VText', {
    staticClass: "v-font-preview__subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.subtitle) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-font-preview__actions"
  }, [_vm._t("actions", function () {
    return [_vm.selectable ? _c('CheckIcon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isSelected,
        expression: "isSelected"
      }]
    }) : _vm._e()];
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "v-font-preview__text",
    style: _vm.fontStyles
  }, [_vm._t("default", function () {
    return [_vm._v("Almost before we knew it, we had left the ground.")];
  })], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-0b43a2d8_0", {
    source: ".v-font-preview[data-v-0b43a2d8]{background:#fff;border:.125rem solid var(--c-color);border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));display:flex;flex-direction:column;padding:0;transition:all var(--g-transition-speed);text-align:left}.v-font-preview--selectable[data-v-0b43a2d8]{cursor:pointer}.v-font-preview--selectable[data-v-0b43a2d8]:focus,.v-font-preview--selectable[data-v-0b43a2d8]:hover{background-color:var(--c-bg-color)}.v-font-preview--selected[data-v-0b43a2d8]{box-shadow:0 2px 3.5px rgba(0,0,0,.15);border-color:var(--c-higlight-color)}.v-font-preview__header[data-v-0b43a2d8],.v-font-preview__text[data-v-0b43a2d8]{padding:1rem}.v-font-preview__header[data-v-0b43a2d8]{padding-bottom:0}.v-font-preview__header-inner[data-v-0b43a2d8]{padding-right:3rem;position:relative}.v-font-preview__title[data-v-0b43a2d8]{font-weight:500;font-size:1.1em}.v-font-preview__subtitle[data-v-0b43a2d8]{color:var(--g-color-gray-600);font-size:.85em}.v-font-preview__actions[data-v-0b43a2d8]{color:var(--c-highlight-color);font-size:2rem;position:absolute;right:0;top:50%;transform:translateY(-50%)}.v-font-preview__text[data-v-0b43a2d8]{color:inherit;font-size:2rem;font-style:normal;line-height:1.15;font-weight:var(--c-font-weight);min-height:5em}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-0b43a2d8";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };